import $ from 'jquery'
import loadMoreButton from './buttons/LoadMoreButton'
import doFilters from './forms/select'

/**
 * Atoms loader.
 * @constructor
 */
export default function atoms () {
  $('.js-load-more-posts').each((i, el) => {
    loadMoreButton().init(el)
  });
  doFilters();
}
